import React, {Component} from 'react';
import {MainNavBar} from "../mainNavBar/MainNavBar";
import { withRouter } from 'react-router-dom';
import './HomeHeader.scss';
import AiChat from '../../common/aiChat/aiChat';
import DiggyAvatar from '../../../styles/assets/Diggy.png';
import HeroBackground from '../../../styles/assets/SafeExcavatorHero.png';


class HomeHeader extends Component {
  constructor(props) {
    super(props);

    this.aiChatRef = null;
    this.setAiChatRef = this.setAiChatRef.bind(this);
    this.handleOpenAiChat = this.handleOpenAiChat.bind(this);
  }

  setAiChatRef(ref) {
    this.aiChatRef = ref;
  }

  handleOpenAiChat() {
    if (this.aiChatRef && this.aiChatRef.openChat) {
      this.aiChatRef.openChat();
    }
  }

  render() {
    
    const ExpertsButton = withRouter(({ history }) => (
      <button
        className={'btn'}
        onClick={() => { history.push('/meet-the-experts') }}
      >
        Meet Now
      </button>
    ));

    return (
      <div id="home-header">
        <MainNavBar
          location={this.props.location}
          match={this.props.match}
        />
             <div
          className="hero-section"
          style={{ backgroundImage: `url(${HeroBackground})` }}
        >
          <div className="hero-overlay-card">
            <div className="hero-text">
              <h1>Meet Diggy</h1>
              <h2>Safe Excavator Assistant</h2>
              <p>
                An AI assistant for 811 call-before-you-dig information and
                state excavation law.
              </p>

              <button
                type="button"
                className="talk-to-diggy"
                onClick={this.handleOpenAiChat}
              >
                CHAT WITH DIGGY
              </button>
            </div>

            <img
              src={DiggyAvatar}
              alt="Diggy Avatar"
              className="hero-avatar"
              onClick={this.handleOpenAiChat}
            />
          </div>
        </div>
        <div>
          <AiChat ref={this.setAiChatRef} />
        </div>
      </div>
    );
  }
}

export default HomeHeader;



// WEBPACK FOOTER //
// ./src/components/common/homeHeader/HomeHeader.js